import { render, staticRenderFns } from "./Stashboard.vue?vue&type=template&id=09c1f7bf&scoped=true&"
import script from "./Stashboard.vue?vue&type=script&lang=js&"
export * from "./Stashboard.vue?vue&type=script&lang=js&"
import style0 from "./Stashboard.vue?vue&type=style&index=0&id=09c1f7bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c1f7bf",
  null
  
)

export default component.exports